export const allDemandsZipUrl = ({ dbName, caseId }) => {
    return `${dbName}/${caseId}/demandLettersZip/Demand_Letters.zip`;
};

export const lifeCarePlanZipUrl = ({ sourceDbName, sourceCaseId }) =>
  `${sourceDbName}/${sourceCaseId}/lifeCarePlanZip/LifeCare_Plan.zip`;

export const certifiedLifecarePlanDownloadBaseName = (caseName) =>
  `${caseName ?? 'case'}_lifecare-plan`;

// canonical AI lifecare PDF filename, shared by the download menu and version history so both name the file the same way
export const lifecarePlanDownloadBaseName = ({ caseName, clientName }) =>
  `${caseName ?? 'case'}_lifecarePlan_${clientName}`;